import PropTypes from 'prop-types';

import CONSTANTS from 'src/store/constants';

import { ModelProp } from 'src/store/typings';
import ActuarialMode from './actuarial';
import ClassifierMode from './classifier';

const ACT_MODEL_TYPES = CONSTANTS.TAL_MODEL.TAGS.slice(2);

export default function LiftCharts(props) {
  // eslint-disable-next-line react/destructuring-assignment
  const { dataModelType } = props.modelView.model;
  if (dataModelType === 'CLASSIFIER') return ClassifierMode(props);
  if (ACT_MODEL_TYPES.includes(dataModelType))
    return ActuarialMode({
      ...props,
      chartMeta: CONSTANTS.TAL_MODEL.ACT_STYLING[dataModelType],
    });
  return null;
}

LiftCharts.propTypes = {
  modelView: PropTypes.shape({
    model: ModelProp,
    gradient: PropTypes.string.isRequired,
    fetchModelStatus: PropTypes.oneOf([PropTypes.string, undefined]).isRequired,
    numBins: PropTypes.number.isRequired,
    chart: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
  }).isRequired,
};
